'use es6';

import Sender from 'conversations-message-history/senders/records/Sender';
import { AGENT } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import memoize from 'transmute/memoize';
export const getCompanyAsSender = memoize(({
  companyLogo,
  customChatName
}) => {
  return new Sender({
    avatar: companyLogo,
    firstName: customChatName,
    senderType: AGENT
  });
});